import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// Data
import data from "../../../../data/posts.json";

// Components
import Magnetic from "../../../Common/Magnetic/Magnetic";
import SearchBar from "../../../Common/SearchBar/SearchBar";

// SCSS
import "./BlogList.scss";

const BlogList = ({ lang, setHoveredElement }) => {
  // Search
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data.filter((post) => {
    const isCorrectLang = post.lang === lang;
    const lowerSearch = searchTerm.toLowerCase();
    const titleMatch = post.title.toLowerCase().includes(lowerSearch);
    const tagMatch = post.tags.some((tag) =>
      tag.toLowerCase().includes(lowerSearch),
    );

    return isCorrectLang && (titleMatch || tagMatch);
  });

  return (
    <div className="BlogList">
      <section className="Search">
        <div className="Search__Wrapper">
          <SearchBar value={searchTerm} onChange={setSearchTerm} />
        </div>
      </section>
      <AnimatePresence mode="popLayout">
        <motion.section
          layout
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{
            opacity: 0,
            transition: { duration: 0.15 },
          }}
          transition={{
            layout: { type: "spring", stiffness: 200, damping: 25 },
            opacity: { duration: 0.2 },
          }}
          className="PostList"
        >
          <div className="PostList__Wrapper">
            {filteredData.length > 0 ? (
              filteredData.map((post) => (
                <Magnetic
                  as="div"
                  key={post.id}
                  setHoveredElement={setHoveredElement}
                  onClick={() => setHoveredElement(null)}
                  className="PostList__Item"
                >
                  <Link to={`/blog/${post.id}`} className="PostItem">
                    <div className="PostItem__Tumbnail">
                      <img
                        src={post.thumbnail}
                        alt={post.title}
                        className="PostItem__Tumbnail-Image"
                      />
                    </div>
                    <div className="PostItem__Title">
                      <h3 className="PostItem__Title-Text">{post.title}</h3>
                      <span className="PostItem__Title-Date">{post.date}</span>
                    </div>
                  </Link>
                </Magnetic>
              ))
            ) : (
              <p className="NoResult">No Result!</p>
            )}
          </div>
        </motion.section>
      </AnimatePresence>
    </div>
  );
};

export default BlogList;
